import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class UzaverkaPokladenProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async uzaverkaPokladny(PokladnaId: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/UzaverkaPokladen?PokladnaId=${PokladnaId}`);
	}

	async getLastTimeUzav(PokladnaId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/LastTimeUzav?PokladnaId=${PokladnaId}`);
	}

	getUzaverkaPokladny(filter:{ uzavId: number, platbaPzn: number[], detail: boolean }) {
		return this.fetchPdf('/Uzaverky/Reports/GetUzaverkaPokladny', filter);
	}
}

export const apiProvider = new UzaverkaPokladenProvider();
